<template>
    <section class="grid-wrapper margin--3xl">

        <h2 class="margin--m">
            {{ i18n.latest }}
        </h2>

        <p class="body--small color--accent-color-dark-grey margin--l" aria-live="polite">
            {{ countLabel }}
        </p>

        <ul ref="list" class="resources__holder grid four">

            <li v-for="item in items" :key="item.id" class="block">
                <ResourceCard :item="item" :icons="icons" />
            </li>

        </ul>

        <slot />

    </section>
</template>

<script setup>
import { computed, ref } from 'vue'

import ResourceCard from './ResourceCard.vue'

const props = defineProps({
    items: { type: Array, default: () => [] },
    total: { type: Number, default: 0 },
    icons: { type: Object, default: () => ({}) },
    i18n: { type: Object, default: () => ({}) },
})

const list = ref(null)

const countLabel = computed(() => {
    const template = props.total === 1 ? props.i18n.showingOne : props.i18n.showingMany

    return (template || '').replace('%s', props.total.toLocaleString())
})

const focusItemAt = (index) => {
    const link = list.value?.querySelectorAll('.block .resource__block')[index]

    if (link) {
        link.focus({ preventScroll: true })
    }
}

defineExpose({ focusItemAt })
</script>
